export const ACTIONS = {
  SELECT: 'SELECT',
};
